'use strict';

const av = Autodesk.Viewing, avp = av.Private;

export default class ViewPortOverlay {
    constructor(viewer) {
        this.viewer = viewer;
        this.overlayName = 'DropMeViewPortOverlay';
    }

    addOverlay(xMin, yMin, xMax, yMax) {
        this.viewer.impl.createOverlayScene(this.overlayName);

        const mesh = this._createMesh(xMin, yMin, xMax, yMax);
        this.viewer.impl.addOverlay(this.overlayName, mesh);
    }

    removeOverlay() {
        this.viewer.impl.removeOverlayScene(this.overlayName);
    }

    _createMesh(xMin, yMin, xMax, yMax) {
        const vpId        = 0;
        const dbId        = -1;
        const layer       = 0;
        const borderColor = 0x99d79606;
        const lineWidth   = 0.1;
        const totalDist   = 0;

        let vbb = new avp.VertexBufferBuilder(false, undefined, 4);

        // add border
        vbb.addSegment(xMin, yMin, xMax, yMin, totalDist, lineWidth, borderColor, dbId, layer, vpId);
        vbb.addSegment(xMax, yMin, xMax, yMax, totalDist, lineWidth, borderColor, dbId, layer, vpId);
        vbb.addSegment(xMax, yMax, xMin, yMax, totalDist, lineWidth, borderColor, dbId, layer, vpId);
        vbb.addSegment(xMin, yMax, xMin, yMin, totalDist, lineWidth, borderColor, dbId, layer, vpId);

        const meshData = vbb.toMesh();
        const mdata = {
            mesh      : meshData,
            is2d      : true,
            packId    : '0',
            meshIndex : 1
        };

        const geom = avp.BufferGeometryUtils.meshToGeometry(mdata);

        const materialParams = {
            skipEllipticals   : true,
            skipCircles       : true,
            skipTriangleGeoms : true,
            skipMiterLines    : true,
            useInstancing     : false
        };

        const matman   = this.viewer.impl.matman();
        const matName  = matman.create2DMaterial(this.viewer.impl.model, materialParams);
        const material = matman.findMaterial(this.viewer.impl.model, matName);

        const mesh = new THREE.Mesh(geom, material);
        return mesh;
    }
}
